// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3olKl","options":"AnswerScale_options__p2ddD","selected":"AnswerScale_selected__yHO2t"};